import { motion } from "framer-motion";
import AgentSeatsCard from "./AgentSeatsCard";
import OperatingModeCard from "./OperatingModeCard";
import CompanyProfileCard from "./CompanyProfileCard";

export default function SettingsPage() {
  return (
    <div data-testid="settings-page" className="px-5 pb-16 pt-6 sm:px-8 sm:pt-8 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        className="mx-auto max-w-5xl"
      >
        <div className="eyebrow">Workspace</div>
        <h1 className="mt-2 text-[40px] font-extrabold leading-[1] tracking-tight text-zinc-900 sm:text-[56px] lg:text-[72px]">
          Settings
        </h1>
        <p className="mt-2 text-[13px] text-zinc-500 sm:text-[14px]">
          Configure your boardroom and company profile.
        </p>

        <div className="mt-8 space-y-5">
          <AgentSeatsCard />
          <OperatingModeCard />
          <CompanyProfileCard />
        </div>
      </motion.div>
    </div>
  );
}
